// eslint-disable-next-line import/order
import jsonWithoutXSS from './strip-xss';

delete window.fetch;

// eslint-disable-next-line global-require
const fetch = require('isomorphic-fetch');

window.fetch = fetch;

if (window.Response) {
    window.Response.prototype.json = jsonWithoutXSS;
}
